<template>
    <RequestMaterial></RequestMaterial>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const RequestMaterial = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/RequestMaterial/RequestMaterial.vue"
    )
);

export default {
    name: "Project_RequestMaterial",
    components: { RequestMaterial, AuthLayout },
};
</script>
